import React, { useRef, FC } from 'react'

import { OKShareButton, VKShareButton } from 'react-share'
import { copyToClipboard } from 'shared/utils'

import classes from './NewsItem.module.scss'

type Props = {
  id: string
  title: string
  image: string
}

export const SocialShare: FC<Props> = ({ title, image, id }) => {
  const url = `${window.location.origin}/news/${id}`
  const ref = useRef<HTMLTextAreaElement>(null)

  return (
    <div className={classes.social_container}>
      {/*<FacebookShareButton url={url} quote={title}>
        <i className={`${classes.social_icon} icon-fb`} />
      </FacebookShareButton>*/}
      <VKShareButton url={url} title={title} image={image}>
        <i className={`${classes.social_icon} icon-vk`} />
      </VKShareButton>
      <OKShareButton url={url} title={title} image={image}>
        <i className={`${classes.social_icon} icon-ok`} />
      </OKShareButton>
      {/*<TwitterShareButton url={url} title={title}>
        <i className={`${classes.social_icon} icon-twitter`} />
      </TwitterShareButton>*/}
      <button
        className={classes.social_btn}
        onClick={() => copyToClipboard(ref.current)}
      >
        <i className={`${classes.social_icon} icon-share`} />
      </button>
      <textarea
        ref={ref}
        value={url}
        id="copy-link"
        readOnly
        style={{ position: 'absolute', opacity: '0', zIndex: -1 }}
      />
    </div>
  )
}
